// Centralised media assets uploaded by the photographer (Alexis "Nono" Lecoeuvre).
// Fighter mapping per client brief:
//   photos 1–4 & 10 → Johein
//   photos 5, 6, 7  → Hadjab
//   photos 8, 9     → Adagio

export const HERO_IMAGE = "/img/hero.webp";

export const PORTFOLIO = [
  { id: "alicia-think", src: "/img/alicia-think.webp", title: "ALICIA — THINK", overlay: "ALICIA", category: "fight", span: "tall" },
  { id: "alicia-ascension", src: "/img/alicia-ascension.webp", title: "ALICIA — ASCENSION", overlay: "ALICIA", category: "portrait", span: "tall" },
  { id: "jaouad-determination", src: "/img/jaouad-determination.webp", title: "JAOUAD — DETERMINATION", overlay: "JAOUAD", category: "fight", span: "tall" },
  { id: "hadjab-entree", src: "/img/hadjab-entree.webp", title: "HADJAB — ENTRÉE", overlay: "HADJAB", category: "fight", span: "tall" },
  { id: "mace-discipline", src: "/img/mace-discipline.webp", title: "MACE — DISCIPLINE", overlay: "MACE", category: "bts", span: "tall" },
  { id: "adagio-apres", src: "/img/adagio-apres.webp", title: "ADAGIO — APRÈS COMBAT", overlay: "ADAGIO", category: "bts", span: "wide" },
  { id: "thomas-focus", src: "/img/thomas-focus.webp", title: "THOMAS — FOCUS", overlay: "THOMAS", category: "bts", span: "tall" },
  { id: "johein-intensite", src: "/img/johein-intensite.webp", title: "JOHEIN — INTENSITÉ", overlay: "JOHEIN", category: "portrait", span: "tall" },
  { id: "kylian-mind", src: "/img/kylian-mind.webp", title: "KYLIAN — MIND", overlay: "KYLIAN", category: "bts", span: "tall" },
  { id: "wbc-belt", src: "/img/wbc-belt.webp", title: "WBC — BELT", overlay: "WBC", category: "bts", span: "tall" },
];

export const INSTAGRAM_URL = "https://www.instagram.com/nono.lcv";
export const CONTACT_EMAIL = "contact@fight-lens.fr";
